var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deviceParentView"},[_c('DeviceListMini',{staticClass:"mb-3",attrs:{"installation-id":_vm.installationId,"device-id":_vm.deviceId}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }